export default "__VITE_ASSET__4df2f511__"